module.exports = __webpack_public_path__ + "static/media/global-shoppng-13.f0a9c98e.png";